// React Query обвивките на складовата карта („Наличности" → клик на продукт) и
// на замените в склада за значката „⇄" в редовете. Ключовете са под
// ["inventory", "stock-history", …] и ["inventory", "substitutions", …] —
// `invalidateAll` (useInventory.ts) вече чисти тези префикси след всяка
// складова мутация, затова картата и значките се опресняват без нов ред там.
// В локален режим (каса без интернет) складът е извън обхвата → заявките мълчат.
import { useQuery } from "@tanstack/react-query";
import { getSubstitutions } from "../api/inventory";
import { getStockCard, type StockCard, type StockCardParams } from "../api/inventoryStockCard";
import { useIsEdgeLocal } from "./useEdgeMode";

export const useStockCard = (params: StockCardParams | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "stock-history", "card", params],
    queryFn: () => getStockCard(params as StockCardParams),
    enabled: !!params && !isLocal,
    // Смяна на периода държи старите редове, докато дойдат новите; смяна на
    // ПРОДУКТА (↑/↓ в списъка) — не: чужди движения под новото име подвеждат.
    placeholderData: (previous: StockCard | undefined) =>
      previous &&
      params &&
      previous.productId === params.productId &&
      previous.warehouseId === params.warehouseId
        ? previous
        : undefined,
  });
};

export type WarehousePeriodParams = {
  warehouseId: number;
  startDate: string;
  endDate: string;
};

// Замените в склада за период — ЕДНА заявка за цялата справка; групирането по
// продукт е в `reports/stockCard/useStockSubstitutionSummary.ts`.
export const useWarehouseSubstitutions = (params: WarehousePeriodParams | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "substitutions", "warehouse", params],
    queryFn: () => getSubstitutions(params as WarehousePeriodParams),
    enabled: !!params && !isLocal,
    staleTime: 60 * 1000,
  });
};
